<template>
    <div>
        <Form style="line-height: 32px" :label-width="120" inline>
            <FormItem
                :label="
                    $t('erp.b2c.attachment_type', { defaultValue: '附件类型' })
                "
                style="width: 90%; margin-bottom: 0"
            >
                <Col span="24" style="width: 100%">
                    <Col span="5">
                        <Select v-model="type" filterable>
                            <Option
                                v-for="item in alltypes"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.name }}</Option
                            >
                        </Select>
                    </Col>
                    <Col span="9" class="margin-left-10">
                        <Row>
                            <Col span="11">
                                <Upload
                                    ref="Upload"
                                    multiple
                                    :before-upload="handleUpload"
                                    action="/api/v2/B2cOrder/uploadAnnex"
                                >
                                    <Button icon="ios-cloud-upload-outline">{{
                                        $t("global.common.select_attachment", {
                                            defaultValue: "请选择文件",
                                        })
                                    }}</Button>
                                </Upload>
                            </Col>
                            <Col span="13">
                                <span v-if="file !== null">{{
                                    file.name
                                }}</span>
                                <!-- <span v-else>{{$t('global.common.no_selectfiles',{defaultValue:'未选择任何文件'})}}</span> -->
                            </Col>
                        </Row>
                    </Col>
                    <Col span="8">
                        <Button type="primary" @click="handerSubmit">{{
                            $t("global.common.upload", { defaultValue: "上传" })
                        }}</Button>
                    </Col>
                </Col>
            </FormItem>
            <div style="margin-left: 60px; color: #ed4014">
                {{
                    $t("erp.distribution.warning_attach", {
                        defaultValue:
                            "注意：附件上传或删除后不会自动推送仓库，推送仓库需要点击“推送仓库”按钮",
                    })
                }}
            </div>
        </Form>
        <!-- 已发货状态展示 -->
        <!-- <div class="tip-font color-error" v-if="orderStatus === 'shipped'">注意：已发货订单上传附件仅做记录，不会推送仓库</div> -->
        <!-- <Table class="margin-top-30" :columns="columns" :data="formList" size="small" ref="table" border></Table> -->
        <Spin size="large" fix v-if="loading"></Spin>
    </div>
</template>
<script>
import { HttpfindAnnexByOrderId, HttpDelAnnex } from "@/service/boss/b2corder";
import { HttpUpload } from "@mods/service/base";

export default {
    props: ["activeids"],
    data() {
        return {
            loading: false,
            type: "",
            file: null,
            alltypes: [
                { value: "0", name: "Shippinglabel" },
                { value: "1", name: "Packinglist" },
                { value: "2", name: "BOL" },
                { value: "3", name: "Other" },
                { value: "4", name: "CartonLabel" },
                { value: "5", name: "PalletLabel" },
                { value: "6", name: "itmelabel" },
            ],
            datalist: [],
        };
    },
    computed: {
        formList() {
            return this.datalist || [];
        },
        columns() {
            const _this = this;
            return [
                {
                    title: this.$t("erp.b2c.attachment_type", {
                        defaultValue: "附件类型",
                    }),
                    width: 150,
                    key: "type",
                    render(h, { row }) {
                        return <div>{row.type}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.attachment_name", {
                        defaultValue: "附件名称",
                    }),
                    width: 250,
                    key: "name",
                    render(h, { row }) {
                        return <div>{row.name}</div>;
                    },
                },
                {
                    title: "URL",
                    key: "url",
                    render(h, { row }) {
                        return (
                            <div>
                                <a
                                    onClick={_this.downpage.bind(
                                        _this,
                                        row.url,
                                        "url"
                                    )}
                                >
                                    {row.url}
                                </a>
                            </div>
                        );
                    },
                },
                // {
                // 	title: this.$t('global.common.operation',{defaultValue:'操作'}),
                // 	width: 80,
                // 	render(h, { row }) {
                // 		return h('div', [
                // 			h('Button', {
                // 				props: {
                // 					type: "error",
                // 					size: 'small'
                // 				},
                // 				on: {
                // 					click: () => {
                // 						_this.remove(row.index, row.id)
                // 					}
                // 				}
                // 			}, _this.$t('global.common.delete',{defaultValue:'删除'}))
                // 		])
                // 	}
                // },
            ];
        },
    },
    created() {
        // this.gettablefile()
    },
    methods: {
        // gettablefile() {
        // 	HttpfindAnnexByOrderId({
        // 		orderId: this.activeids,
        // 		// contextId: 1
        // 	}).then(res => {
        // 		// console.log(res)
        // 		this.datalist = res.data
        // 		this.loading = false;
        // 	}, err => {
        // 		this.loading = false;
        // 		this.errorMessage(err.message);
        // 	})
        // },
        downpage(url) {
            window.open(url, "_blank");
        },
        async upload() {
            // const { action, name } = this.$attrs;
            // let action = process.env.VUE_APP_APIURL_BOSS + "/api/v2/B2cOrder/uploadAnnex"
            let action =
                process.env.VUE_APP_APIURL_BOSS +
                "/api/v2/DeliverOrder/uploadAttach";
            const formData = new FormData();
            formData.append("file", this.file);
            formData.append("deliverOrderId", this.activeids);
            formData.append("type", this.type);
            formData.append("contextId", global.SYSID);
            HttpUpload(action, formData).then(
                (res) => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.$emit("on-update");
                    this.$emit("on-close");
                    this.file = null;
                    this.type = null;
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.errorMessage(err.message);
                }
            );
        },
        handleUpload(file) {
            let fileName = file.name;
            fileName = fileName.toLowerCase();
            if (
                fileName.endsWith(".jpg") ||
                fileName.endsWith(".jpeg") ||
                fileName.endsWith(".pdf") ||
                fileName.endsWith(".png")
            ) {
                this.file = file;
                return false;
            }
            this.$VMessage.error(
                this.$t("erp.distribution.upload_format_error", {
                    defaultValue: "只能上传jpg/jpeg/pdf/png格式的文件",
                })
            );
            return false;
            // this.file = file;
            // return false;
        },
        handerSubmit() {
            if (!this.file || !this.type)
                return this.$VMessage.error(
                    this.$t("erp.distribution.attachment_not_null", {
                        defaultValue: "附件类型/文件不可以为空！",
                    })
                );
            this.loading = true;
            this.upload();
        },

        cancel() {
            this.loading = false;
            this.$emit("on-close");
        },
        remove(index, annexid) {
            this.loading = true;
            HttpDelAnnex({
                orderId: this.activeids,
                annexId: annexid,
            }).then(
                (res) => {
                    this.loading = false;
                    this.$Message.success(res.message);
                    this.cancel();
                },
                (err) => {
                    this.loading = false;
                    this.errorMessage(err.message);
                }
            );
        },
    },
};
</script>
<style lang="scss" scoped>
.tip-font {
    margin-left: 60px;
}
</style>
